module.exports = __webpack_public_path__ + "img/79.263d43cd.png";